
<div
    v-if="shouldRender()"
    class="MaintenanceNotification"
    :class="{ 'is-overview-page': isOverviewPage, 'is-expanded': isExpanded }"
>
    <div class="MaintenanceNotification-header" @click="toggleExpanded">
        <div class="MaintenanceNotification-content">
            <i class="ri-tools-line"></i>

            <template v-if="isOverviewPage">
                <span class="MaintenanceNotification-text">
                    {{ notification.message }}
                </span>
            </template>
            <template v-else>
                <span class="MaintenanceNotification-text" v-if="isExpanded">
                    {{ notification.message }}
                </span>
            </template>

            <i
                class="MaintenanceNotification-toggle ri-arrow-down-s-line"
                :class="{ 'is-expanded': isExpanded }"
            ></i>
        </div>
    </div>

    <div v-if="isExpanded" class="MaintenanceNotification-details">
        <div class="MaintenanceNotification-detail-item">
            <span class="detail-label">Geplante Wartung:</span>
            <span class="detail-value">{{ formattedStartTime }}</span>
        </div>
        <div class="MaintenanceNotification-detail-item">
            <span class="detail-label">Erwartetes Ende:</span>
            <span class="detail-value">{{ formattedEndTime }}</span>
        </div>
        <div class="MaintenanceNotification-detail-item">
            <span class="detail-label">Zeit bis zur Wartung:</span>
            <span class="detail-value">
                <span v-if="isCheckingStatus" class="checking-status">
                    <i class="ri-loader-4-line"></i>
                    Überprüfe Status...
                </span>
                <span v-else-if="isMaintenanceTimePassed" class="maintenance-passed">
                    {{ activeMaintenanceMessage }}
                </span>
                <span v-else>{{ timeUntilMaintenance }}</span>
            </span>
        </div>
    </div>
</div>
